import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{commentsData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{commentsData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {commentsData.items.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                  <span className="text-primary-500 text-sm font-extrabold">{item.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.nickname}</div>
                  <div className="text-[11px] text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-[13px] text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line text-sm"></i>
                  {item.likes}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line text-sm"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}